import { TRIGGER_RULES_ORDER, ACTION_RULES_ORDER } from 'constants/automation';

export const prepareAutomationForEdit = automation => {
    if (!automation?.trigger) {
        return null;
    }

    const trigger = Object.keys(automation.trigger)
        .map(id => {
            const value = automation.trigger[id];

            if (Array.isArray(value) && value.length === 0) {
                return {
                    id,
                    value: 'any'
                };
            }

            return {
                id,
                value
            };
        })
        .filter(({ id }) => id !== 'resource_exclude')
        .sort((a, b) => TRIGGER_RULES_ORDER.indexOf(a.id) - TRIGGER_RULES_ORDER.indexOf(b.id));

    const action = (Array.isArray(automation.action) ? automation.action : [automation.action]).map(action => Object.keys(action)
        .map(id => ({
            id,
            value: action[id]
        }))
        .sort((a, b) => ACTION_RULES_ORDER.indexOf(a.id) - ACTION_RULES_ORDER.indexOf(b.id)));

    trigger[trigger.length - 1].isLast = true;
    action.forEach(a => {
        a[a.length - 1].isLast = true;
    });

    return {
        trigger,
        action,
        name: automation.name
    };
};
